import axios from 'axios';

var api = {
  // 获取OSS直传授权信息
  getAuthInfo: function (fileDir) {
    return axios({
      url: '',
      method: 'get',
      params: {}
    });
  }
}

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js